"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Calendar = void 0;
var react_1 = __importDefault(require("react"));
var calendar_1 = require("@react-stately/calendar");
var calendar_2 = require("@react-aria/calendar");
var i18n_1 = require("@react-aria/i18n");
var date_1 = require("@internationalized/date");
var gds_ux_components_1 = require("@granular/gds-ux-components");
var common_1 = require("@granular/gds-ux-components/lib/common");
var clsx_1 = __importDefault(require("clsx"));
var GKDateInput_1 = require("./GKDateInput");
require("./Calendar.css");
var Calendar = function (props) {
    var locale = (0, i18n_1.useLocale)().locale;
    var state = (0, calendar_1.useCalendarState)(__assign(__assign({}, props), { locale: locale, createCalendar: date_1.createCalendar }));
    var QA = props["data-qa"];
    var ref = react_1.default.useRef(null);
    var _a = (0, calendar_2.useCalendar)(props, state), calendarProps = _a.calendarProps, prevButtonProps = _a.prevButtonProps, nextButtonProps = _a.nextButtonProps, title = _a.title;
    var isPrevDisabled = prevButtonProps.isDisabled, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    prevPress = prevButtonProps.onPress, prevProps = __rest(prevButtonProps, ["isDisabled", "onPress"]);
    var isNextdisabled = nextButtonProps.isDisabled, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    nextPress = nextButtonProps.onPress, nextProps = __rest(nextButtonProps, ["isDisabled", "onPress"]);
    var setOpenState = react_1.default.useContext(GKDateInput_1.GKDateInputContext).setOpenState;
    (0, common_1.useActionOutsideElement)(ref, function (isOutside) { return isOutside && setOpenState(false); });
    return (react_1.default.createElement("div", __assign({}, calendarProps, { ref: ref, className: "gk-calendar d-flex flex-column bg-white p-4 border rounded" }),
        react_1.default.createElement("div", { className: "gk-calendar--header pb-4" },
            react_1.default.createElement("h4", { className: "gk-calendar--title", "data-qa": QA + "--title" }, title),
            react_1.default.createElement(gds_ux_components_1.GKButton, __assign({}, prevProps, { className: "gk-calendar--prev", "data-qa": QA + "--prev", disabled: isPrevDisabled, onClick: function () { return state.focusPreviousPage(); }, size: "sm", color: "link", icon: gds_ux_components_1.GKIconName.ArrowBack })),
            react_1.default.createElement(gds_ux_components_1.GKButton, __assign({}, nextProps, { className: "gk-calendar--next", "data-qa": QA + "--next", disabled: isNextdisabled, onClick: function () { return state.focusNextPage(); }, size: "sm", color: "link", icon: gds_ux_components_1.GKIconName.ArrowForward }))),
        react_1.default.createElement(CalendarGrid, { state: state, "data-qa": QA + "--grid", id: props.id + "--grid" })));
};
exports.Calendar = Calendar;
var CalendarGrid = function (_a) {
    var state = _a.state, props = __rest(_a, ["state"]);
    var locale = (0, i18n_1.useLocale)().locale;
    var _b = (0, calendar_2.useCalendarGrid)(props, state), gridProps = _b.gridProps, headerProps = _b.headerProps, weekDays = _b.weekDays;
    var monthStart = (0, date_1.startOfWeek)(state.visibleRange.start, locale);
    var weeksInMonth = (0, date_1.getWeeksInMonth)(state.visibleRange.start, locale);
    return (react_1.default.createElement("table", __assign({}, gridProps, { id: props.id, "data-qa": props["data-qa"], className: "gk-calendar--grid" }),
        react_1.default.createElement("thead", __assign({}, headerProps),
            react_1.default.createElement("tr", null, weekDays.map(function (day, index) { return (react_1.default.createElement("th", { key: index }, day)); }))),
        react_1.default.createElement("tbody", null, __spreadArray([], new Array(weeksInMonth), true).map(function (v, i) { return i; })
            .map(function (weekIndex) { return (react_1.default.createElement("tr", { key: weekIndex }, __spreadArray([], new Array(7), true).map(function (v, i) { return i; })
            .map(function (dayIndex) { return (react_1.default.createElement(CalendarCell, { key: dayIndex, state: state, date: monthStart.add({ weeks: weekIndex, days: dayIndex }) })); }))); }))));
};
var CalendarCell = function (_a) {
    var state = _a.state, date = _a.date;
    var ref = react_1.default.useRef(null);
    var _b = (0, calendar_2.useCalendarCell)({ date: date }, state, ref), cellProps = _b.cellProps, buttonProps = _b.buttonProps, isSelected = _b.isSelected, isOutsideVisibleRange = _b.isOutsideVisibleRange, isDisabled = _b.isDisabled, isUnavailable = _b.isUnavailable, formattedDate = _b.formattedDate;
    return (react_1.default.createElement("td", __assign({}, cellProps),
        react_1.default.createElement("div", __assign({}, buttonProps, { ref: ref, className: (0, clsx_1.default)("cell", {
                selected: isSelected,
                disabled: isDisabled,
                unavailable: isUnavailable,
                outside: isOutsideVisibleRange,
                today: (0, date_1.isToday)(date, (0, date_1.getLocalTimeZone)()),
            }) }), formattedDate)));
};
